/*
| New Message        | 1   |
| User Locked        | 10  |
| Order Placed       | 20  |
| Order Updated      | 21  |
| Order Cancelled    | 22  |
| Invoice Issued     | 30  |
| Invoice Paid       | 31  |
| Invoice Failed     | 32  |
| Proposal Requested | 40  |
| Proposal Updated   | 41  |
| Proposal Accepted  | 42  |
| Cart Item Updated  | 50  |
*/


export const NotificationType = {
  Message: {
    New: 1
  },
  User: {
    Locked: 10
  },
  Order: {
    Placed: 20,
    Updated: 21,
    Cancelled: 22,
  },
  Invoice: {
    Issued: 30,
    Paid: 31,
    Failed: 32
  },
  Quotation: {
    Requested: 40,
    Updated: 41,
    Accepted: 42
  },
  Cart: {
    ItemUpdated: 50
  }
}